var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50016 2.08325C5.13016 2.08325 1.5835 5.62992 1.5835 9.99992C1.5835 14.3699 5.13016 17.9166 9.50016 17.9166C13.8702 17.9166 17.4168 14.3699 17.4168 9.99992C17.4168 5.62992 13.8702 2.08325 9.50016 2.08325ZM3.16683 9.99992C3.16683 6.50075 6.001 3.66659 9.50016 3.66659C10.9647 3.66659 12.3106 4.16534 13.3793 5.0045L4.50475 13.8791C3.66558 12.8103 3.16683 11.4645 3.16683 9.99992ZM9.50016 16.3333C8.03558 16.3333 6.68975 15.8345 5.621 14.9953L14.4956 6.12075C15.3347 7.1895 15.8335 8.53534 15.8335 9.99992C15.8335 13.4991 12.9993 16.3333 9.50016 16.3333Z",
    fill: "#EF4444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/Block.303f32a96b5b44a1b7288b1fef35e31a.svg";
export { ForwardRef as ReactComponent };